import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv"; // Import CSVLink
import Sidebar from "../components/Sidebar"; // Import Sidebar component
import api from "../utils/api"; // Adjust the import based on your file structure
import { useAuth } from "../context/AuthContext"; // Use AuthContext to get token

const OrdersEmail = () => {
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { token } = useAuth(); // Get the token from AuthContext

  useEffect(() => {
    const fetchEmails = async () => {
      try {
        const response = await api.get("/orders/allOrders", {
          headers: {
            Authorization: `Bearer ${token}`, // Pass the token in headers
          },
        });

        // Extract contactEmail from each order
        const extractedEmails = response.data.map((order) => order.contactEmail);
        setEmails(extractedEmails);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchEmails();
  }, [token]); // Dependency on token to ensure it updates on login

  if (loading)
    return (
      <div className="flex justify-center items-center h-screen">
        Loading emails...
      </div>
    );
  if (error)
    return (
      <div className="flex justify-center items-center h-screen text-red-500">
        Error fetching emails: {error.message}
      </div>
    );

  // Prepare data for CSV
  const csvData = emails.map((email, index) => ({
    No: index + 1,
    Email: email,
  }));

  return (
    <div className="flex flex-col md:flex-row">
      {/* Sidebar */}
      <Sidebar />

      {/* Content */}
      <div className="flex-1 p-4 md:p-6 bg-gray-50">
        <h1 className="text-2xl md:text-3xl font-bold mb-4 text-gray-700">
          Order Emails
        </h1>

        {/* Export Button */}
        <div className="mb-4">
          <CSVLink
            data={csvData}
            headers={[
              { label: "No", key: "No" },
              { label: "Email", key: "Email" },
            ]}
            filename="order-emails.csv"
            className="bg-primary text-black px-4 py-2 rounded shadow hover:bg-primary-dark transition duration-200"
          >
            Export to CSV
          </CSVLink>
        </div>

        {/* Emails List */}
        <div className="bg-white rounded-lg shadow-md p-6">
          {emails.length > 0 ? (
            <ul className="space-y-4">
              {emails.map((email, index) => (
                <li
                  key={index}
                  className="p-4 bg-gray-100 rounded-lg hover:bg-gray-200 transition duration-200 text-gray-800"
                >
                  {email}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-600">No emails found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrdersEmail;
